module.exports = __webpack_public_path__ + "static/aboutbg-caeab8766d5016b4efdc41cd15cfd819.mp4";